import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { TextBlock } from 'bench-internal-theme';

// Inherited from TextBlock
const LINE_HEIGHT = 16;

const PADDING_BOTTOM_HEIGHT = 32;

const NoDataMessageLayout = styled(TextBlock)`
  margin: 0 32px;
  overflow: hidden;
  padding-bottom: ${PADDING_BOTTOM_HEIGHT}px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
class NoDataMessage extends PureComponent {
  static getHeight = () => LINE_HEIGHT + PADDING_BOTTOM_HEIGHT;

  render() {
    return <NoDataMessageLayout>Nothing during this date range</NoDataMessageLayout>;
  }
}

export default NoDataMessage;
